import RedirectPage from 'src/components/common/RedirectPage';
import { customToast } from 'src/services/toast';

const CampaignTopupCancel = () => (
	<RedirectPage
		callback={() =>
			customToast(
				'Credit purchase was cancelled. Please try again to launch your campaign.',
				'error',
			)
		}
	/>
);

export default CampaignTopupCancel;
